import type { ReactNode } from 'react';
import { cx } from '@/lib/cx';
import { Icon } from './Icon';
import s from './Banner.module.css';

export type BannerTone = 'info' | 'warn' | 'neg' | 'brand' | 'pos';

const icons: Record<BannerTone, string> = {
  info: 'info',
  warn: 'warning',
  neg: 'error',
  brand: 'lightbulb',
  pos: 'check_circle',
};

export function Banner({
  tone = 'info',
  icon,
  children,
  aside,
  action,
  className,
}: {
  tone?: BannerTone;
  icon?: string | null;
  children: ReactNode;
  /** Right-aligned secondary text. */
  aside?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cx(s.banner, s[tone], className)} role={tone === 'neg' || tone === 'warn' ? 'alert' : undefined}>
      {icon !== null && <Icon name={icon ?? icons[tone]} size={18} className={s.icon} />}
      <div className={s.text}>{children}</div>
      {aside && <span className={s.aside}>{aside}</span>}
      {action}
    </div>
  );
}
